import React, { useImperativeHandle, useRef } from "react";
import PropTypes from "prop-types";
import { StyledSeeker } from "./styled";
import { FaCaretDown } from "react-icons/fa";

const Seeker = React.forwardRef(
  ({ parentId, pos, onChangePosition, onDrag }, ref) => {
    const innerSeekerRef = useRef(null);

    useImperativeHandle(ref, () => ({
      innerSeekerRef,
    }));

    return (
      <StyledSeeker
        ref={ref}
        bounds={parentId}
        enableResizing={false}
        default={{
          height: "100%",
          x: pos,
          y: 0,
        }}
        dragAxis="x"
        position={{
          x: pos,
          y: 0,
        }}
        onDrag={onDrag}
        onDragStop={onChangePosition}
      >
        <div id="inner-seeker" ref={innerSeekerRef} className="seeker">
          <FaCaretDown />
        </div>
      </StyledSeeker>
    );
  }
);

Seeker.propTypes = {
  parentId: PropTypes.string.isRequired,
  pos: PropTypes.number,
  onChangePosition: PropTypes.func,
  onDrag: PropTypes.func.isRequired,
};

export default Seeker;
